import { render, staticRenderFns } from "./MaintenanceConfig.vue?vue&type=template&id=72b05329"
import script from "./MaintenanceConfig.vue?vue&type=script&lang=js"
export * from "./MaintenanceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports